import { render, staticRenderFns } from "./Receipt-report.vue?vue&type=template&id=6210536a"
import script from "./Receipt-report.vue?vue&type=script&lang=js"
export * from "./Receipt-report.vue?vue&type=script&lang=js"
import style0 from "./Receipt-report.vue?vue&type=style&index=0&id=6210536a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports